import { AccessGrant, Query, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { generateMockAccessGrant } from 'mocks/graphqlMocks/accessGrant';
import { removeFields } from 'mocks/graphqlMocks/removeFields';
import { generateMockVisitorGroup } from 'mocks/graphqlMocks/visitorGroup';
import { generateMockWeekSchedule } from 'mocks/graphqlMocks/weekSchedule';
import { generateMockWeekScheduleDay } from 'mocks/graphqlMocks/weekScheduleDay';
import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';

export function mockedGetVisitorGroupsForTenantWithSchedulesData(
  getVisitorGroupsForTenant: Array<VisitorGroup>
): Pick<Query, 'getVisitorGroupsForTenant'> {
  return {
    getVisitorGroupsForTenant
  };
}

const fieldsToRemoveFromVisitorGroups: (keyof VisitorGroup)[] = [
  'allowedAccessGrants',
  'defaultAccessGrants',
  'scheduledAccessGrants',
  'externalRef',
  'isAdminGroup',
  'isQrCodeVisitInviterGroup',
  'maxNumberOfMembers',
  'members',
  'memberIds',
  'tenantId'
];

const fieldsToRemoveFromAccessGrant: (keyof AccessGrant)[] = [
  'doors',
  'doorIds',
  'isOfficeModeEnabled',
  'locations',
  'locationIds',
  'name',
  'tenantId'
];

export const mockedGetVisitorGroupsWithSchedulesForTenantDataForQuery =
  mockedGetVisitorGroupsForTenantWithSchedulesData([
    removeFields(
      generateMockVisitorGroup({
        id: 'mockedVisitorGroupIdWithSchedules',
        name: 'mockedVisitorGroupNameWithSchedules',
        accessGrants: [
          removeFields(
            generateMockAccessGrant({
              id: 'mockedAccessGrantWithDays',
              accessSchedule: generateMockWeekSchedule({
                weekDays: [generateMockWeekScheduleDay({ dayName: 'monday', from: '07:00', to: '18:00' })]
              })
            }),
            fieldsToRemoveFromAccessGrant
          )
        ]
      }),
      fieldsToRemoveFromVisitorGroups
    ),
    removeFields(
      generateMockVisitorGroup({
        id: 'mockedVisitorGroupIdWithSchedules1',
        name: 'mockedVisitorGroupNameWithSchedules1',
        accessGrants: [
          removeFields(
            generateMockAccessGrant({
              id: 'mockedAccessGrantWithDays1',
              accessSchedule: generateMockWeekSchedule({
                weekDays: [
                  generateMockWeekScheduleDay({ dayName: 'monday', from: '07:00', to: '18:00' }),
                  generateMockWeekScheduleDay({ dayName: 'tuesday', from: '07:00', to: '18:00' })
                ]
              })
            }),
            fieldsToRemoveFromAccessGrant
          )
        ]
      }),
      fieldsToRemoveFromVisitorGroups
    ),
    removeFields(
      generateMockVisitorGroup({
        id: 'mockedVisitorGroupIdWithSchedules2',
        name: 'mockedVisitorGroupNameWithSchedules2',
        accessGrants: [
          removeFields(
            generateMockAccessGrant({
              id: 'mockedAccessGrantWithDays2',
              accessSchedule: generateMockWeekSchedule({
                weekDays: [
                  generateMockWeekScheduleDay({ dayName: 'monday', from: '07:00', to: '18:00' }),
                  generateMockWeekScheduleDay({ dayName: 'wednesday', from: '09:00', to: '17:00' })
                ]
              })
            }),
            fieldsToRemoveFromAccessGrant
          )
        ]
      }),
      fieldsToRemoveFromVisitorGroups
    ),
    removeFields(
      generateMockVisitorGroup({
        id: 'mockedVisitorGroupIdWithSchedules3',
        name: 'mockedVisitorGroupNameWithSchedules3',
        accessGrants: [
          removeFields(
            generateMockAccessGrant({
              id: 'mockedAccessGrantWithDays3',
              accessSchedule: generateMockWeekSchedule({
                weekDays: [
                  generateMockWeekScheduleDay({ dayName: 'monday', from: '07:00', to: '18:00' }),
                  generateMockWeekScheduleDay({ dayName: 'tuesday', from: '07:00', to: '18:00' }),
                  generateMockWeekScheduleDay({ dayName: 'wednesday', from: '07:00', to: '18:00' }),
                  generateMockWeekScheduleDay({ dayName: 'thursday', from: '07:00', to: '18:00' }),
                  generateMockWeekScheduleDay({ dayName: 'friday', from: '07:00', to: '18:00' })
                ]
              })
            }),
            fieldsToRemoveFromAccessGrant
          )
        ]
      }),
      fieldsToRemoveFromVisitorGroups
    ),
    removeFields(
      generateMockVisitorGroup({
        id: 'mockedVisitorGroupIdWithSchedules4',
        name: 'mockedVisitorGroupNameWithSchedules4',
        accessGrants: [
          removeFields(
            generateMockAccessGrant({
              id: 'mockedAccessGrantWithDays4',
              accessSchedule: generateMockWeekSchedule({
                weekDays: [
                  generateMockWeekScheduleDay({ dayName: 'sunday', from: '07:00', to: '14:00' }),
                  generateMockWeekScheduleDay({ dayName: 'saturday', from: '07:00', to: '14:00' })
                ]
              })
            }),
            fieldsToRemoveFromAccessGrant
          )
        ]
      }),
      fieldsToRemoveFromVisitorGroups
    ),
    removeFields(
      generateMockVisitorGroup({
        id: 'mockedVisitorGroupIdWithSchedules5',
        name: 'mockedVisitorGroupNameWithSchedules5',
        accessGrants: [
          removeFields(
            generateMockAccessGrant({
              id: 'mockedAccessGrantWithDays5',
              accessSchedule: generateMockWeekSchedule({
                weekDays: [
                  generateMockWeekScheduleDay({ dayName: 'sunday', from: '07:00', to: '14:00' }),
                  generateMockWeekScheduleDay({ dayName: 'saturday', from: '07:00', to: '14:00' })
                ]
              })
            }),
            fieldsToRemoveFromAccessGrant
          )
        ]
      }),
      fieldsToRemoveFromVisitorGroups
    )
  ]);

export const mockedGetVisitorGroupsWithSchedulesForTenantDataAdmin = mockedGetVisitorGroupsForTenantWithSchedulesData([
  generateMockVisitorGroup({
    id: 'mockedIdInstallers',
    name: 'installers',
    accessGrants: [
      generateMockAccessGrant({
        id: 'mockedAccessGrantIdInstallers',
        accessSchedule: generateMockWeekSchedule({
          weekDays: []
        })
      })
    ]
  }),
  generateMockVisitorGroup({
    id: 'mockedIdCleaners',
    name: 'cleaners',
    accessGrants: [
      generateMockAccessGrant({
        id: 'mockedAccessGrantIdCleaners',
        accessSchedule: generateMockWeekSchedule({
          weekDays: [generateMockWeekScheduleDay({ dayName: 'monday', from: '07:00', to: '18:00' })]
        })
      })
    ]
  }),
  generateMockVisitorGroup({
    id: 'mockedIdCo-contractors',
    name: 'co-contractors',
    accessGrants: [
      generateMockAccessGrant({
        id: 'mockedAccessGrantIdCo-contractors',
        accessSchedule: generateMockWeekSchedule({
          weekDays: []
        })
      })
    ]
  }),
  generateMockVisitorGroup({
    id: 'mockedIdAdmins',
    name: 'admins',
    accessGrants: [
      generateMockAccessGrant({
        id: 'mockedAccessGrantIdAdmins',
        accessSchedule: generateMockWeekSchedule({
          weekDays: []
        })
      })
    ],
    type: VisitorGroupType.AzureAd
  }),
  generateMockVisitorGroup({
    id: 'mockedIdEmployees',
    name: 'employees',
    accessGrants: [
      generateMockAccessGrant({
        id: 'mockedAccessGrantIdEmployees',
        accessSchedule: generateMockWeekSchedule({
          weekDays: []
        })
      })
    ],
    type: VisitorGroupType.AzureAd
  }),
  generateMockVisitorGroup({
    id: 'mockedIdVisitor_group_1',
    name: 'visitor_group_1',
    accessGrants: [
      generateMockAccessGrant({
        id: 'mockedAccessGrantIdVisitor_group_1',
        accessSchedule: generateMockWeekSchedule({
          weekDays: [generateMockWeekScheduleDay({ dayName: 'monday', from: '07:00', to: '18:00' })]
        })
      })
    ],
    type: VisitorGroupType.AzureAd
  }),
  generateMockVisitorGroup({
    id: 'mockedIdVisitor_group_2',
    name: 'visitor_group_2',
    accessGrants: [
      generateMockAccessGrant({
        id: 'mockedAccessGrantIdVisitor_group_2',
        accessSchedule: generateMockWeekSchedule({
          weekDays: []
        })
      })
    ],
    type: VisitorGroupType.AzureAd
  }),
  generateMockVisitorGroup({
    id: 'mockedIdVisitor_group_3',
    name: 'visitor_group_3',
    accessGrants: [
      generateMockAccessGrant({
        id: 'mockedAccessGrantIdVisitor_group_3',
        accessSchedule: generateMockWeekSchedule({
          weekDays: []
        })
      })
    ],
    type: VisitorGroupType.AzureAd
  }),
  generateMockVisitorGroup({
    id: 'mockedIdVisitors',
    name: 'visitors',
    accessGrants: [
      generateMockAccessGrant({
        id: 'mockedAccessGrantIdVisitors',
        accessSchedule: generateMockWeekSchedule({
          weekDays: []
        })
      })
    ],
    type: VisitorGroupType.ExternalVisitors
  })
]);
